import { IconButton, SvgIcon } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import Popper from "@mui/material/Popper";
import TextField from "@mui/material/TextField";
import { grey } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { theme } from "../styles/theme";
import CircleChevronLeftIcon from "./icons/CircleChevronLeftIcon";

export default function AutocompleteStyled({
  options,
  label,
  placeholder,
  value,
  onChange,
  PaperComponent,
  fatherRegion,
  changeToFather,
  ...props
}) {
  const StyledPopper = styled(Popper)({
    "& ul": {
      maxHeight: "16rem",
    },
    "& li": {
      textAlign: "left",
    },
  });

  const handleSelected = (event, value) => {
    if (onChange) {
      onChange(event, value);
    }
  };

  return (
    <>
      {label && <InputLabel>{label}</InputLabel>}
      <Autocomplete
        sx={autocompleteStyles}
        options={options}
        getOptionLabel={props.getOptionLabel}
        onChange={handleSelected}
        disablePortal={true}
        PopperComponent={StyledPopper}
        PaperComponent={PaperComponent}
        noOptionsText="Keine Ergebnisse"
        value={value}
        renderInput={(params) => (
          <TextField
            {...params}
            type="text"
            variant="filled"
            placeholder={placeholder || "BITTE WÄHLEN"}
            sx={{
              "& .MuiFilledInput-root": {
                "&::before": {
                  borderColor: "transparent",
                },
              },
              "& .Mui-disabled": {
                backgroundColor: "#F2F2F2",
              },
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: fatherRegion && (
                <>
                  <InputAdornment
                    position="start"
                    sx={{ marginTop: "unset !important" }}
                  >
                    <IconButton
                      onClick={changeToFather}
                      aria-label="Zurück"
                      sx={{ padding: "0" }}
                    >
                      <SvgIcon
                        sx={{
                          "& path": {
                            fill: grey[400],
                            transition: "all .2s ease-in-out",
                            "&:hover": {
                              fill: theme.palette.secondary.main,
                            },
                          },
                        }}
                      >
                        <CircleChevronLeftIcon />
                      </SvgIcon>
                    </IconButton>
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
}

const autocompleteStyles = {
  "& .MuiFilledInput-root": {
    padding: ".1875rem 0 .1875rem 1rem",
    minHeight: "42px",
    "& ::placeholder": {
      color: "#1a1a1a",
      opacity: "1!important",
      textTransform: "uppercase",
      fontSize: "1rem",
    },

    "& input": {
      padding: "unset !important",
    },

    "& .MuiChip-root": {
      height: "1.75rem",
      borderRadius: ".25rem",
      color: theme.palette.common.white,
      margin: ".1875rem .5rem .1875rem 0",

      "&::before": {
        content: "''",
        margin: "auto",
        width: "1rem",
        height: "1rem",
        left: "0",
        top: "0",
        bottom: "0",
        position: "absolute",
        transform: "translateX(.5rem)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
      },

      "& .MuiChip-label": {
        marginLeft: "1rem",
      },
    },

    "& .MuiAutocomplete-option": {
      textAlign: "left",
    },
  },

  "& label": {
    display: "none",
  },
};
